import styles from "../../../assets/css/mainLoader.module.css";

const MainLoader = () => {
  return (
    <div className={styles.loaderIcon}>
      {/* Main gear */}
      <div className={styles.gear}>
        <div className={styles.gearInner}>
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className={styles.tooth} />
          ))}
          <div className={styles.gearCircle}></div>
          <div className={styles.gearCenter}></div>
        </div>
      </div>

      {/* Small accent gear 1 */}
      <div className={`${styles.smallGear} ${styles.smallGear1}`}>
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className={styles.smallTooth} />
        ))}
        <div className={styles.smallGearCircle}></div>
      </div>

      {/* Small accent gear 2 */}
      <div className={`${styles.smallGear} ${styles.smallGear2}`}>
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className={styles.smallTooth} />
        ))}
        <div className={styles.smallGearCircle}></div>
      </div>
    </div>
  );
};

export default MainLoader;
